const LocalesEnum = {
	En: 'en',
	Vi: 'vi',
};

export default LocalesEnum;
